
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|4761|5839|6985)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
